export default __webpack_public_path__ + "static/media/triassicpark-logo-S.0810e1db.png";